jQuery(document).ready(function($) {
	if($("#facilities").length === 0) return;

	$(".content").css("padding-bottom", 150);

	$(this).docketChart();
});